export enum  HousingType{

    P = 'OWNER' ,   // Propietario

    A = 'RENT' ,  //Alquiler

    F = 'FAMILY_HOME',

    E = 'COMPANY_HOUSING',

    X = 'UNKNOWN'
}